export default {
  module_title: 'Robot platform',
  messages: {
    license_fail_message: 'Get licenses failed',
    org_fail_message: 'Get organizational list failed',
    product_fail_message: 'Get the user product list failed',
    role_user_cannot_delete_message: 'The current role has allocated the user not to delete.The allocation of the current role can be canceled, then delete the role',
    org_cannot_empty_msg: 'The organization name cannot be empty',
    org_exist_msg: 'Organization name already exists',
    upper_org_cannot_be_empty: "Admiral organizations can't be empty",
    status_cannote_be_empty: 'State cannot be empty',
    role_empty_message: "Role name can't be empty",
    source_empty_message: "Information source can't be empty",
    check_delete_user: 'Role {user} existed',
    no_product_msg: 'No product is not allocated under the organization',
    no_selected_org: 'Have not selected organization',
  },
  general: {
    place_holder: 'Enter keyword search',
    hide: 'Hide',
    system_name_default: 'Bot factory',
    enter: 'Enter',
    platform_name: 'Robot platform',
    range: 'range',
    confirm: 'Confirm',
    name: 'Name',
    image: 'Picture',
    icon: 'icon',
    clear_all: 'Clear all',
    reset_to_default: 'Restore default',
    pink_all: 'Select all',
    view: 'View',
    custom_column: 'Custom column',
    default_column: 'Default column',
    enable: 'Enable',
    disable: 'Disable',
    setting: 'Settings',
    language: 'language',
    zh_tw: '繁體中文',
    zh_cn: '简体中文',
    us_en: 'English',
    delete_success: 'Delete successfully',
    robot_list: 'Robot list',
    im: 'IM',
    no_data: 'No data',
    no_search_data: 'No query results yet',
    no_option: 'No option',
    no_filterable_option: 'No filterable results',
    clearchecked: 'Delete selected items',
    reset: 'Reset',
    chat_test: 'Function test',
    custom: 'Custom',
    yes: 'Yes',
    no: 'No',
    empty: 'None',
    operation: 'Operation',
    search: 'Query',
    all: 'All',
    add: 'Add',
    actions: 'Operation',
    status: 'Status',
    edit: 'Edit',
    delete: 'Delete',
    remove: 'Remove',
    question: 'Question',
    answer: 'Answer',
    ext_answer: 'answer extension',
    ok: 'Confirm',
    cancel: 'Cancel',
    canceled: 'Canceled',
    confirm_edit: 'Confirm modification',
    already_cancel: 'Cancelled',
    loading: 'Page loading',
    table_loading: 'Table loading...',
    error_code: 'Error code',
    error: 'Error',
    upload: 'Upload',
    browse: 'Browse',
    copy: 'Copy',
    save: 'Save',
    saving: 'Saving',
    default: 'Default',
    indicate: 'Specify',
    force_cancel: 'Forced cancellation',
    import: 'Import',
    export: 'Export',
    success: 'Success',
    fail: 'Failed',
    description: 'Prompt',
    file: 'File',
    finish: 'Finish',
    folder: 'Directory',
    search_placeholder: 'Please enter search content',
    close: 'Close',
    test: 'Test',
    modify: 'Modify',
    save_change: 'Save changes',
    go_back: 'Return',
    please_choose: 'Please choose',
    intent: 'Intent',
    select_all: 'Select all',
    download: 'Download',
    batch_import: 'Batch import',
    unit1: 'bar',
    unit2: 'unit',
    start_date: 'Start time',
    end_date: 'End time',
    batch_upload: {
      only_xlsx_xls: 'Only supports xlsx, xls format files',
      file_invalid: 'File validation error',
      upload_file: 'Upload file',
      choose_file: 'Choose file',
      download_template: 'Download template',
      upload_mode: 'Upload mode',
      add_data: 'Add data',
      add_data_desc: 'Only add valid data without duplicates',
      replace_all: 'Full replacement',
      replace_all_desc: 'Full replacement will delete all current data before uploading the file data. Please exercise caution and pay attention to data backup',
      tip: 'Notes',
      tips: '1. Support xlsx file format for uploading</br>2. Please refer to the document description in the template and fill in according to the format</br>3. Full replacement will replace all data and cannot be restored. It is recommended to backup first data',
      empty_file: 'The uploaded content is empty, please select the file again!',
      oversize_file: 'The number of uploaded lines cannot exceed %1 lines',
      confirm_upload: 'Confirm import',
    },
    export_all: {
      title: 'Data Export',
      export_current: 'Export current data',
      upload_history: 'Import History',
      history_count: 'Only keep the imported data for nearly %d times',
      file_name: 'Document name',
      upload_time: 'Upload time',
      action: 'Operation',
      download: 'Download',
      download_error: 'Error report',
      status: 'Status',
      upload_success: 'Import successful',
      upload_fail: 'Import failed',
      file_replaced: 'File is overwritten',
      no_sheet_file: 'The target page cannot be found in the uploaded file',
      invalid_templ_version: 'Import template version does not fit',
      part_success: 'Partially imported successfully',
      upload_type: 'Upload mode',
      add_mode: 'Increment',
      replace_mode: 'full amount',
    },
    log_off: 'Log off',
    load_more: 'Load more',
    note: 'Note',
    detail: 'Details',
    license_expired: 'The license has expired, please contact the administrator',
    edit_success: 'Operation successful',
    serial: 'Serial Number',
    pending: 'Loading...',
    normal: 'normal',
    abnormal: 'Abnormal',
    total: 'Total {total} items',
    uploading: 'File uploading...',
    dataLoading: 'Data Loading...',
    switch: 'Switch',
    ok_modify: 'OK to modify',
    ok_add: 'OK to add',
    tempLoading: 'Getting the template...',
    line_wrap: 'Force Wrap',
    on: 'Open',
    off: 'Off',
    load_temp: 'Load template',
    batch_delete: 'Batch delete',
    reload: 'Refresh',
    open_filter: 'Advanced',
    close_filter: 'Collapse',
    copied: 'Copy successful',
    license_probation_expired: 'The trial period has expired, please contact the administrator to apply for a license',
  },
  management: {
    role_add_success: 'New role is created successful',
    role_add_fail: 'Role creation failure',
    role_update_success: 'Role update success',
    role_update_fail: 'Role update failed',
    role_delete_success: 'Role delete success',
    role_delete_fail: 'Role delete failed',
    user_has_no_role: 'The user has not been assigned a role',
    no_active_org: 'There is currently no active organization to choose from',
    user_amount: 'Number of users',
    product: 'Product',
    add_position: 'Add role',
    role_manage: 'Role authority management',
    basic_info: 'Basic information',
    admin_account: 'System administrator account',
    position_edit: 'Edit role',
    position_add: 'Add role',
    position_name: 'Character name',
    please_enter_position_name: 'Please enter the role name',
    data_auth: 'Data Authority',
    data_source: 'Data source',
    please_choose_data_source: 'Please choose data source',
    please_choose_data_source_sub_type: 'Please select the data source subtype',
    operation_right: 'Operation authority',
    ccbot_auth_operate: 'Outbound platform permission configuration',
    to_ccbot_auth_operate: 'Access to outbound platform permission configuration',
    no_interrupt_tip: 'After entering, it will not affect the current configuration operations of other platforms',
    all_access_user: 'This user can use all the functions of the product',
    add_confirm: 'Confirm to add',
    basic_info_setting: 'Basic information settings',
    update_confirm: 'Confirm to edit',
    role_assign: 'Assign role',
    enable: 'Enable',
    enabled: 'Enabled',
    disable: 'Disable',
    disabled: 'Disabled',
    encrypt_title: 'Robot export encryption settings',
    encrypt_tips: 'Please set a password for this file',
    file_pwd: 'File password',
    file_pwd_confirm: 'Confirm password',
    file_pwd_placeholder: 'Please enter the file password',
    file_pwd_confirm_placeholder: 'Confirm password',
    confirm_export: 'Confirm and export',
    import_encrypt_title: 'Robot import',
    import_encrypt_tips: 'This file has been encrypted, please enter the file password',
    import_pwd_tips: 'If you forget the password, please contact the administrator or re-export the file',
    confirm_import: 'OK and import',
    pwd_empty: 'Neither the password nor the confirmed password can be empty',
    pwd_error: 'Passwords are inconsistent',
    pwd_reg_tips: 'Please enter 6-16 digits or English',
    exporting_msg: 'Exporting, please wait~',
    import_err_msg: 'Import failed! {message}',
    import_moudule_err_msg: 'Because the {messaeg} module failed to import',
    robot_group_placeholder: 'Search robot group',
    robot_list_placeholder: 'Search robot',
    import_robot: 'Import robot',
    total_robot_message: 'hi {name}, you have created {num} robots',
    open: 'Enabled',
    un_use: 'Not Enabled',
    add_enterprise_success: 'Add Enterprise Success',
    add_enterprise_fail: 'Add Enterprise Fail',
    edit_enterprise_success: 'Enterprise modification is successful',
    enterprise_setting: 'Enterprise Settings',
    organization_list: 'Enterprise organization',
    enterprise_status: 'Business status',
    enterprise_search_text: 'Enter the company name search',
    user_management: 'User Management',
    role_list: 'Role permissions',
    icon_setting: 'Icon Settings',
    enterprise_icon_setting: 'Enterprise icon setting',
    enterprise_lu_icon: 'Enterprise upper left icon',
    enterprise_lu_icon_info: 'Support formats svg, png, file size limit is 1mb, recommended image size is 22px*22px',
    browser_page_icon: 'Browser tab',
    browser_page_icon_info: 'Support format png, file size limit is 1mb, recommended aspect ratio 20px*20px',
    table_robot_list: 'Robot list',
    table_group_name: 'Group name',
    robot_template: 'Robot template',
    return_to_robot_list: 'Return to robot list',
    import_robot_running: 'Robot is being imported...',
    import_robot_time: 'It is estimated to take 10 minutes',
    create_from_template: 'Create from template',
    list_robot_name: 'Robot',
    operate: 'Operation',
    upload_wating: 'The current import task has not been completed, please wait for the task to complete before operating',
    upload_success: 'Import successful',
    export_wating: 'There are currently robots being exported, please wait a moment',
    faq_count: 'Standard Q&A:',
    te_count: 'Task scene:',
    system_setting: 'System Settings',
    gatway_setting: 'Landing gateway settings',
    inbound_and_scenario_setting: 'Inbound routing and scenario configuration',

    icon_management: 'Icon management',
    system_icon_setting: 'System icon setting',
    system_lu_icon: 'System upper left icon',
    login_icon: 'Login screen icon',
    login_icon_info: 'Support format svg, png, file size limit is 1mb, recommended file size is 320px*45px',
    group_name: 'Group name',
    enterprise_list: 'Enterprise Management',
    admin_list: 'Administrator Settings',
    enterprise: 'Enterprise',
    create_enterprise: 'Create an enterprise',
    delete_enterprise: 'Delete enterprise',
    edit_enterprise: 'Edit Enterprise',
    create_time: 'Create time',

    enterprise_name: 'Enterprise Name',
    enterprise_description: 'Enterprise description',
    module_list: 'Function list',
    product_list: 'The company can use the following products',

    system_admin_list: 'System administrators',
    system_admin_desc: 'When creating an enterprise, an enterprise administrator must be appointed',

    robot_group: 'Robot group',
    robots: 'Robot',
    robot_list: 'Robot list',

    create_robot: 'Create a new robot',
    delete_robot: 'Delete robot',
    edit_robot: 'Edit robot',
    group_manage: 'Robot group management',

    robot_name: 'Robot name',
    description: 'Description',
    no_description: 'No description information',
    input_placeholder: 'Enter text',
    length_50_placeholder: 'The word limit is within 50',
    chat_language: 'Dialogue language',

    create_group: 'Create group',
    edit_group: 'Edit group',
    delete_group: 'Delete group',
    add_robot: 'Add robot',
    input_personal_pass: 'Enter personal password',
    reason_description: 'reason description',

    user_preference: 'Personal Information',
    edit_data: 'Modify data',
    edit_user_preference: 'Modify profile',

    enterprise_privilege_manage: 'Enterprise Privilege Management',
    add_account: 'Add account',
    edit_account: 'Editor',
    add_role: 'Add permission',
    privilege_setting: 'Privilege Settings',
    role_name_placeholder: 'Enter role name',
    normal_user: 'General user',
    enterprise_admin: 'Enterprise Administrator',
    system_admin: 'System Administrator',
    unknown: 'Unknown',

    user_name: 'ID',
    user_type: 'Account Type',
    user_display_name: 'Name',
    phone: 'Contact phone',
    email: 'Email',
    next_step: 'Next',
    last_step: 'Previous step',
    password: 'Password',
    set_password: 'Set password',
    check_password: 'Confirm password',
    modify_password: 'Modify password',
    set_passowrd_placeholder: 'Please enter your password',
    set_right_origin_pwd: 'Please enter the correct old password',
    check_password_placeholder: 'Enter the password again',
    assign_robot: 'Specify a robot',
    privilege_is: 'Privilege is',

    manager_password: 'Administrator password',
    orig_password: 'Original password',
    new_password: 'New password',
    check_new_password: 'Confirm new password',
    password_format: 'English letters, numbers or symbols between 6~16 words, must contain uppercase and lowercase English letters and numbers',
    username_format: 'English letters, numbers or @._- between 4~64 characters',
    err_empty_username: 'ID cannot be empty',
    err_existed_username: 'ID already exists',
    err_username_length: 'ID length must be between 4~64 characters',
    err_invalid_username: 'Illegal ID format',
    err_empty_email: 'Email cannot be empty',
    err_invalid_email: 'Illegal Email format',
    err_invalid_phone: 'Illegal phone format',
    err_empty_display_name: 'Name cannot be empty',
    err_display_name_length: 'The length of the name must be between 2~50 characters',
    err_password_length: 'Password length must be between 6~16 characters',
    err_password_invalid: 'Illegal password format',
    err_password: 'Password error',
    err_origin_password: 'The original password is wrong',
    err_manager_password: 'Administrator password error',
    err_manager_empty_password: 'The administrator password cannot be empty',
    err_origin_empty_password: 'The original password cannot be empty',
    err_invalid_check_password: 'The two password entries are different',
    update_password_success: 'Update password successfully',
    add_user_success: 'Add user successfully',
    err_update_password_fail: 'Failed to update password',
    err_role_duplicate: 'The role name already exists',
    err_robot_name_empty: 'Robot name cannot be empty',
    err_robot_duplicate: 'Robot name already exists',
    err_enterprise_name_empty: 'The length of the enterprise name must be between 1 and 50 characters',
    err_enterprise_duplicate: 'enterprise name already exists',

    err_group_name_empty: 'The group name cannot be empty',
    err_group_duplicate: 'Group name already exists',
    err_pick_no_modules: 'At least one of the feature list must be checked',
    err_reason_empty: 'Reason for deletion cannot be empty',
    err_enterprise_admin_duplicate: 'Enterprise administrator account name already exists',
    err_enterprise_email_duplicate: 'The enterprise administrator mailbox already exists',
    err_unkown: 'An unknown error occurred',
    err_add_robot_fail: 'Add robot failed',
    err_add_robot_fail_license: 'The number of authorized robots has been used up',
    go_back: 'Return',
    audit: {
      system: 'System Operation Record',
      enterprise: 'Enterprise Operation Record',
      robot: 'Robot operation record',
      filter_time: 'Occurrence time',
      filter_robot: 'Robot',
      filter_module: 'Operation module and type',
      filter_userid: 'User ID',
      filter_enterprise: 'Enterprise',
      total: 'Total {num} items',
    },
    privilege: {
      statistic_dash: {
        view: 'Statistics overview',
      },
      ssm: {
        view: 'Commonly used standard Q&A view',
        edit: 'Commonly used standard Q&A editing',
        export: 'Common standard Q&A export',
        import: 'Commonly used standard Q&A import',
      },
      qa_label: {
        view: 'Tag management view',
        edit: 'Tag management edit',
      },
      ssm3: {
        view: 'View standard Q&A',
        import: 'Import data',
        export: 'Export data',
        'create-sq': 'Manually add standard Q&A',
        'del-sq': 'Delete standard question',
        'edit-sq': 'Edit standard question',
        'edit-answer': 'Edit answer',
        'edit-lq': 'Edit corpus',
        train: 'Training data',
        test: 'Test and report',
        publish: 'Publish online',
        'edit-label': 'Manage label',
      },
      qa_records: {
        view: 'review changes',
      },
      task_engine: {
        edit: 'Task Engine Edit',
      },
      wordbank: {
        view: 'View',
        edit: 'Edit',
        create: 'Add',
        delete: 'Delete',
        import: 'Import',
        export: 'Export',
      },
      statistic_analysis: {
        view: 'Statistical analysis view',
        export: 'Statistical analysis export',
      },
      statistic_daily: {
        view: 'Log Management View',
        export: 'Log management export',
      },
      statistic_audit: {
        view: 'Operation record view',
        export: 'Operation record export',
      },
      robot_profile: {
        view: 'Robot image view',
        edit: 'Robot image editing',
      },
      robot_chat_skill: {
        view: 'Talking settings view',
        edit: 'Edit speech settings',
      },
      robot_function: {
        view: 'Skill settings view',
        edit: 'Skill settings edit',
      },
      robot_command: {
        view: 'Command setting view',
        edit: 'Instruction settings edit',
      },
      intent_manage: {
        view: 'Intention Management View',
        edit: 'Intention management edit',
        export: 'Intention management export',
        import: 'Intention management import',
      },
      integration: {
        view: 'Access deployment view',
        edit: 'Access deployment edit',
      },
      robot_config: {
        view: 'Robot setting view',
        edit: 'Robot settings change',
      },
      ner_factory: {
        view: 'View',
        edit: 'Edit',
        create: 'Add',
        delete: 'Delete',
        import: 'Import',
        export: 'Export',
      },
      domain_kg: {
        view: 'Knowledge reasoning engine view',
        edit: 'Knowledge reasoning engine edit',
        delete: 'Knowledge reasoning engine delete',
        import: 'Knowledge reasoning engine import',
      },
      health_check: {
        view: 'View health check',
        edit: 'Edit health check',
      },
    },
    org: {
      all_org: 'All organize',
      businessOrgan_list: 'Business Organization',
      treeTitle: 'Organizational relationship',
      rightHeader: 'Organization List-',
      rightStatus: 'Organization Status',
      placeholder: 'Enter text, press Enter to search',
      addOrg: 'New Organization',
      tableName: 'Organization Name',
      tableUp: 'Superior organization',
      tablePro: 'Available products',
      tableStatus: 'Status',
      tableOr: 'Operation',
      editOrg: 'Edit Organization',
      confirm: 'OK to create',
      editSure: 'OK to modify',
      editStatus: 'Status modified successfully',
      popup: {
        title: 'Basic Information',
        orgName: 'Organization Name',
        orgUp: 'superior organization',
        status: 'Status',
        product: 'The organization can use the following products',
        placeholder: 'Enter organization name',
        addSuccess: 'New organization succeeded',
        upSuccess: 'Modify the organization successfully',
      },
    },
    userManage: {
      userManage_list: 'User Management',
      rightHeader: 'User account management',
      rightOrg: 'Owning Organization',
      rightStatus: 'User Status',
      addAccount: 'Add account',
      name: 'Username',
      accountType: 'Account Type',
      lastName: 'Name',
      phone: 'Contact number',
      Email: 'Email',
      ownerOrg: 'Owning Organization',
      siblingOrg: 'Associated Organization',
      status: 'Status',
      operate: 'Operation',
      placeholder: 'Enter text, press Enter to search',
      userType: 'Start to create',
      addSuccess: 'New user success',
      upSuccess: 'Modify user successfully',
      popup: {
        adduser: 'Add account',
        edituser: 'Edit account',
        confirm: 'OK to create',
        editSure: 'OK to modify',
        account: 'Account Information',
        username: 'Username',
        name: 'Name',
        phone: 'Contact phone',
        Email: 'Email',
        password: 'Set password',
        updatePw: 'New password',
        updateSurePw: 'Confirm new password',
        surePassword: 'Confirm password',
        adminPw: 'Administrator Password',
        status: 'User status',
        ownerOrg: 'Owning Organization',
        siblingOrg: 'Associated Organization',
        guest: 'General user',
        admin: 'Enterprise Administrator',
        placeholder: 'Please choose',
        placeholderUser: 'Please enter your username',
        placeholderName: 'Please enter your name',
        placeholderPhone: 'Please enter the contact phone number',
        placeholderEmail: 'Please enter the contact email address',
        placeholderAdmin: 'Please enter the administrator password',
        placeholderPs: 'Please enter the password to be set',
        placeholderSureMsg: 'Please enter the password again',
        password_format: 'English letters, numbers or symbols between 6~16 words, must contain uppercase and lowercase English letters and numbers',
        username_format: 'English letters, numbers or @._- between 4~64 characters',
        sectionTitle: 'Role Assignment',
        robot: 'Designated robot',
        roles: 'Roles',
        addButton: 'Add a specified robot',
        addRoleButton: 'Add a specified role',
        noRobot: 'Role assignment is not currently supported',
      },
    },
    model_management: 'Model Management',
  },
  privileges: {
    role: 'Role',
    user: 'User',
    password: 'Password',
    role_name: 'Role name',
    user_name: 'Username',
    privileges: 'Permissions',
    user_count: 'Number of users',
    function_priv: 'Function Privilege',

    placeholder_user_name: 'Please enter your username',
    placeholder_password: 'Please enter a password',
    placeholder_modify_password: 'Enter the password if you want to change',
    placeholder_input_role_name: 'Please enter the role name',

    enterprise_admin: 'Enterprise Administrator',

    no_roles: 'No roles exist',
    no_users: 'No users exist',
    all_active: 'Open all',
    all_deactive: 'Close all',

    check_delete: 'Confirm to delete role: {role}',
    check_delete_user: 'Confirm to delete user: {user}',
    check_cancel_user: 'Confirm to cancel the user: {user}',
    delete_success: 'Delete successfully',
    err_need_create_role: 'Please add a role first',
    err_role_empty: 'The role cannot be empty',

    actions: {
      edit: 'Edit',
      view: 'View',
      create: 'Add',
      delete: 'Delete',
      export: 'Export',
      import: 'Import',
      login: 'Login',
      logout: 'Logout',
      publish: 'Publish',
      active: 'Start',
      deactive: 'Close',
      train: 'training',
      revert: 'Revert',
      sync: 'Sync',
      mark: 'Mark',
      ignore: 'Ignore',
      cluster: 'Auxiliary classification',
      sq_add: 'Add standard question',
      sq_edit: 'Modify standard question',
      sq_delete: 'Delete standard question',
      sq_import: 'Upload standard problem',
      sq_publish: 'Standard issue publication',
      lq_add: 'Add corpus',
      lq_edit: 'Save/Modify Extension',
      lq_delete: 'Delete corpus',
      lq_import: 'Upload corpus',
      ans_add: 'Add answer',
      ans_edit: 'Edit answer',
      test_import: 'Upload test questions',
    },

    modules: {
      statistic_dash: 'Statistics Overview',
      statistic_analysis: 'Statistical Analysis',
      statistic_daily: 'Log Management',
      statistic_audit: 'Operation record',
      statistic_heatlh_check: 'health check',

      ssm: 'Common Standard Questions',
      qa_label: 'label management',
      ssm3: 'Common Standard Questions',
      qa_records: 'Audit changes',
      domain_kg: 'Knowledge Reasoning Engine',
      health_check: 'Health check',
      ccs_config: 'Central Control System',

      qalist: 'Q&A library',
      qatest: 'Dialog test',
      qa_chat_skill: 'Talking skills settings',
      qa_rule: 'Rule Management',

      robot_profile: 'Robot profile',
      robot_chat_skill: 'Talking skills settings',
      robot_function: 'Skill settings',
      robot_command: 'Command settings',
      robot_config: 'Robot Settings',
      wordbank: 'Thesaurus',
      task_engine: 'Task Engine',

      management: 'Permission Management',
      intent_manage: 'Intent Engine',
      integration: 'Access deployment',
      chat_test_tools: 'Dialog test',
      material: 'Material Library',
    },
    tools: {
      encrypt: {
        title: 'Encryption Tool',
        button: 'Encryption',
        copy_button: 'Copy',
        placeholder: {
          encrypt_from: 'Enter the text to be encrypted',
          encrypt_to: 'The encryption result will be displayed here',
        },
        fail: 'Encryption failed',
        copied: 'The encrypted text has been copied',
      },
    },
  },
  pages: {
    null: '',
    manage_admin: {
      module_name: 'System Manager',
    },
    manage_enterprise: {
      module_name: 'Enterprise List',
    },
    manage_user: {
      module_name: 'Enterprise User Management',
    },
    manage_robot: {
      module_name: 'Robot list',
    },
    status: {
      module_name: 'Data overview',
      statistic_dash: 'Statistics Overview',
    },
    ccs: {
      module_name: 'Dialog management',
    },
    ssm: {
      module_name: 'Question and Answer Management',
      ssm: 'Common Standard Questions',
      qa_label: 'label management',
      history: 'Change record',
    },
    chat_tools: {
      module_name: 'tool',
      chat: 'Dialog test tool',
    },
    privileges: {
      module_name: 'Permission Management',
      role_manage: 'Role Management',
      user_manage: 'User Management',
      other_tools: 'Other tools',
    },
    robot_setting: {
      module_name: 'Robot Settings',
      robot_profile: 'Robot profile',
      robot_function: 'Skill settings',
      robot_chat_skill: 'Talking skills settings',
      robot_command: 'Command settings',
      integration: 'Access deployment',
      robot_config: 'System function configuration',
      message: 'If you set multiple answers, your robot will randomly choose one answer to reply. \n' +
        'If you set a dimension for the answer, the answer can only be applied on the specified dimension; if there is no setting, it will be applied for the full range of dimensions. ',
      check_other_question: 'View other questions',
      add_answer: 'Add answer',
      edit_answer: 'answer edit',
      edit_question: 'Question to edit',
      other_question: 'Do you hope that there are other ways to ask this question? ',
      add_question: 'Add question method',
      cancel: 'Cancel',
      add: 'Add',
      no_question: 'No other questioning method',
      save: 'OK to save',
      confirm_modification: 'Confirm modification',
      quit_modification: 'Quit modification',
      err_empty_robot: 'The answer content cannot be empty',
      demo_question: 'Sample Question Method',
      hotspot_issues: 'Hot issues configuration',
    },
    wordbank: {
      module_name: 'Thesaurus',
      wordbank_list: 'Thesaurus relationship',
      wordbank_upload: 'Thesaurus import',
    },
    faq: {
      module_name: 'Question and Answer Management',
      qalist: 'Q&A library',
      qa_greeting: 'greeting library',
      qatest: 'Dialog test',
      qa_chat_skill: 'Talking skills settings',
      qa_label: 'label management',
      qa_rule: 'Rule Management',
      qa_learning: 'Self-learning',
    },
    statistics: {
      module_name: 'Dialog data',
      statistic_analysis: 'Statistical Analysis',
      statistic_daily: 'Log Management',
      statistic_audit: 'Operation record',
      statistic_learning: 'Negative feedback',
      statistic_session: 'session log',
      statistic_heatlh_check: 'health check',
    },
    task_engine: {
      module_name: 'Task Engine',
      task_engine_scenario: 'Scenario List',
      task_engine_scenario_v2: 'Scenario List',
      task_engine_scenario_v3: 'TDE scenario list',
      task_engine_upload: 'Upload conversion data',
    },
    knowledge_graph: {
      module_name: 'Knowledge Reasoning Engine',
      property_manage: 'Property Management',
      relation_manage: 'Entity Management',
      material_manage: 'Change review',
      test_report: 'Test report',
      data_manage: 'Data Management',
    },
    intent_engine: {
      module_name: 'Intent Engine',
      intent_manage: 'Intent management',
      intent_manage_old: 'Old intent management',
      intent_test: 'Intent test',
    },
    ner: {
      module_name: 'Custom parser',
      ner_extractor: 'Extractor',
      ner_wordbank_upload: 'Thesaurus import',
      ner_test_report: 'Test and report',
    },
    material: {
      module_name: 'Material Library',
      manage: 'Material management',
    },
    manage_model: {
      module_name: 'Model Management',
    },
    error: '',
  },
  statistics: {
    day: ' Day',
    export_mode: 'Advanced',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/us-en.js